import {CHECK_TENANT_EXITS} from "@/core/services/store/mtenant.module";
export default async function checkTenantExits ({ to,form,next, store }){
    await store.dispatch(CHECK_TENANT_EXITS,to.params.tenant_dir);
    return next();
}
